module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/checkbox/checkbox.component.scss
// module id = ./src/app/shared/checkbox/checkbox.component.scss
// module chunks = main